import * as pdfjsLib from 'pdfjs-dist/es5/build/pdf';
import workerContent from '../../static/pdf.worker.min.json';

export default class Pdf {
  constructor(url) {
    return (async () => {
      try {
        this._setupPdfWorker();
        this.pdf = url ? await pdfjsLib.getDocument(url).promise : null;
        this.canvas = null; // Initialize canvas as null
      } catch (error) {
        throw error; // Rethrow the error for the caller to handle
      }
      return this; // Return the class instance
    })();
  }

  _setupPdfWorker() {
    const workerBlob = new Blob([workerContent], { type: 'text/javascript' });
    pdfjsLib.GlobalWorkerOptions.workerSrc = URL.createObjectURL(workerBlob);
  }

  // Fetch and render a page to a canvas
  async getPage(pageNumber) {
    if (!this.pdf) {
      throw new Error('PDF document is not loaded.');
    }

    try {
      const page = await this.pdf.getPage(pageNumber);

      const PDF_DPI = 72; // PDF default DPI
      const TARGET_DPI = 150;
      const scalingFactor = TARGET_DPI / PDF_DPI;

      const viewport = page.getViewport({ scale: scalingFactor });

      // Create or reuse canvas
      if (this.canvas) {
        this.canvas.remove();
      }
      this.canvas = document.createElement('canvas');
      this.canvas.height = viewport.height;
      this.canvas.width = viewport.width;

      const ctx = this.canvas.getContext('2d', {
        alpha: false, // No transparency needed for PDFs
        willReadFrequently: false, // We only read pixels once for dataURL
      });

      const renderContext = {
        canvasContext: ctx,
        viewport,
        enableWebGL: true, // Use GPU acceleration when available
        renderInteractiveForms: false, // Skip form rendering
      };

      await page.render(renderContext).promise;

      return {
        dataUrl: this.canvas.toDataURL('image/jpeg', 0.8),
        scale: scalingFactor,
      };
    } catch (error) {
      console.error(`Error rendering page ${pageNumber}:`, error);
      throw error;
    }
  }
}
